import React from 'react'
import { View, Text } from 'react-native'
import { useTheme } from '../../theming/ThemeProvider'
import PropTypes from 'prop-types'

const NoAvailableData = ({ message }) => {
  const { theme } = useTheme()
  return (
    <View style={{ justifyContent: 'center', alignItems: 'center' }}>
      <Text style={{ fontSize: 16, padding: 10, color: theme.BUNKER }}>{message}</Text>
    </View>
  )
}

NoAvailableData.propTypes = {
  message: PropTypes.string
}

export default NoAvailableData
